// extracted by mini-css-extract-plugin
export default {"title":"Bev7H6V9wSa3BSC5Qe1e","list":"gnjCWxWXQjTRHmOP4uOT","item":"_iIob7tAUV_B2jBhecF0"};